export enum IdPageEnum {
    // ADP
    ACCUEIL_ADP = "ACCUEIL_ADP",
    DETAIL_EOP_ADP = "DETAIL_EOP_ADP",
    DETAIL_MARGE_CREDIT_ADP = "DETAIL_MARGE_CREDIT_ADP",
    ERREUR_ADP = "ERREUR_ADP",
    TRANSACTIONS_ADP = "TRANSACTIONS_ADP",

    // ADP Prospect
    ACCUEIL_PROSPECT_ADP = "ACCUEIL_PROSPECT_ADP",
    ERREUR_PROSPECT_ADP = "ERREUR_PROSPECT_ADP",

    // ADA
    ACCUEIL_ADA = "ACCUEIL_ADA",
    DETAIL_EOP_ADA = "DETAIL_EOP_ADA",
    DETAIL_ES_ADA = "DETAIL_ES_ADA",
    DETAIL_ET_ADA = "DETAIL_ET_ADA",
    DETAIL_CS_ADA = "DETAIL_CS_ADA",
    DETAIL_CARTE_CREDIT_ADA = "DETAIL_CARTE_CREDIT_ADA",
    DETAIL_COMPTE_CREDIT_ADA = "DETAIL_COMPTE_CREDIT_ADA",
    PAIEMENT_PAR_VERSEMENT_ADA = "PAIEMENT_PAR_VERSEMENT_ADA",
    ERREUR_ADA = "ERREUR_ADA",
}
